import { ChevronLeft, Menu } from 'lucide-react'
import { useLocation, useNavigate } from 'react-router'
import { useLayoutStore } from '@/shared/store/layoutStore'
import { AiButton } from '@/features/ai/AiButton'
import { Button } from '@/shared/ui'

interface TopBarProps {
  title: string
  subtitle?: string
}

export function TopBar({ title, subtitle }: TopBarProps) {
  const navigate = useNavigate()
  const stackTitle = useLayoutStore((state) => state.stackTitle)
  const stackBack = useLayoutStore((state) => state.stackBack)
  const location = useLocation()
  const canGoBack = typeof window.history.state?.idx === 'number' && window.history.state.idx > 0
  const path = location.pathname.replace(/\/+$/, '') || '/'
  // 하단 탭 루트는 스택 0 — 뒤로가기가 없다.
  const isHome = ['/', '/home', '/qsc/home', '/prm/home', '/qa/home', '/more', '/comm'].includes(path)
  // QA 하위 화면끼리 오가더라도 뒤로가기는 항상 QA 홈으로 모은다.
  const isQaSection = path.startsWith('/qa/')
  const goBack = () => {
    // 상세 화면이 열려 있으면 앱 뒤로가기 대신 그 화면을 닫는다.
    if (stackBack) {
      stackBack()
      return
    }
    if (isQaSection) {
      navigate('/qa/home', { replace: true })
      return
    }
    if (canGoBack) navigate(-1)
    else if (!isHome) navigate('/home', { replace: true })
  }
  const setDrawerOpen = useLayoutStore((state) => state.setDrawerOpen)

  return (
    <header
      data-qsc-chrome="true"
      className="flex h-[calc(3.5rem+var(--safe-top))] shrink-0 items-center justify-between gap-3 border-b border-border-subtle bg-surface px-4 pt-[var(--safe-top)] lg:hidden"
    >
      {(!isHome || stackBack) && (
        <Button
          variant="ghost"
          size="icon"
          onClick={goBack}
          aria-label="뒤로가기"
          className="size-11 shrink-0"
        >
          <ChevronLeft aria-hidden className="size-5" />
        </Button>
      )}
      <div className="min-w-0 flex-1">
        <h1 className="truncate text-preset-body-strong text-text">
          {stackTitle ?? (title === '홈' ? 'bizbee QSC' : title)}
        </h1>
        {subtitle && !stackTitle && (
          <p className="truncate text-preset-helper text-text-subtle">{subtitle}</p>
        )}
      </div>
      <div className="flex shrink-0 items-center gap-1">
        <AiButton />
        <Button
          variant="ghost"
          size="icon"
          className="size-11"
          onClick={() => setDrawerOpen(true)}
          aria-label="메뉴 열기"
        >
          <Menu aria-hidden className="size-5" />
        </Button>
      </div>
    </header>
  )
}
